import React from "react";
import styled from "styled-components";
import type { StampInformation } from "../../../models/ClientInvoiceReaderTemplateModel";
import type { Position } from "../../../models/Position";
import PdfOverlayBox from "./PdfOverlayBox";
import "@fontsource/inter";
import "@fontsource/inter/700.css";

interface StampBoxProps {
  defaultPosition: Position;
  pdfHeight: number;
  scale: number;
  stampInformation: StampInformation;
  borderColor?: string;
  onChange?: (pos: Position) => void;
  isDraggable?: boolean;
}

const StampTextContainer = styled.div`
  font-family: "Inter", sans-serif;
  font-size: 9.6px;
  user-select: none;
  line-height: 15px;
`;
const PaymentText = styled.div`
  font-family: "Inter", sans-serif;
  font-size: 9.6px;
  user-select: none;
  font-weight: 600;
`;

const StampBox: React.FC<StampBoxProps> = ({
  defaultPosition,
  pdfHeight,
  scale,
  stampInformation,
  borderColor,
  onChange,
  isDraggable = true,
}) => {
  return (
    <PdfOverlayBox
      defaultPosition={defaultPosition}
      pdfHeight={pdfHeight}
      scale={scale}
      onChange={onChange}
      isDraggable={isDraggable}
    >
      <div
        style={{
          border: `1px solid ${borderColor || "black"}`,
          background: "white",
          padding: 4,
          width: "100%",
          height: "100%",
          boxSizing: "border-box",
        }}
      >
        <StampTextContainer>{stampInformation.text}</StampTextContainer>
        <PaymentText>
          {stampInformation.bankText} {stampInformation.bankTextValue}
          &nbsp;&nbsp;
          {stampInformation.paymentText} {stampInformation.paymentTextValue}
        </PaymentText>
      </div>
    </PdfOverlayBox>
  );
};

export default StampBox;
